import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';
import SectionDivider from 'modules/shared/common/components/SectionDivider';

import {
  VendorListNoResultsWrapper,
  VendorListNoResultsText,
  VendorsListWrapper,
  VendorsListGridWrapper,
  VendorsListHeader,
  VendorsListDivider,
  VendorsListItem,
  VendorsListItemText,
  VendorsListItemSubText,
  VendorListItemStatus,
  VendorListIconBtn,
} from './VendorsList.style';

const VendorsList = ({
  mappedVendorsList,
  stringsData,
  vendorStatusEnum,
  vendorStatusColorEnum,
  handleVendorEditButtonClick,
}) => {
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const themeContext = useContext(ThemeContext);
  const { colors } = themeContext;
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  const vendorsGridHeaderList = stringsData.vendorsList.vendorGridHeader;
  if (mappedVendorsList.length === 0)
    return (
      <VendorListNoResultsWrapper>
        <VendorListNoResultsText>
          {stringsData.vendorsList.vendorGridNoResultsFound}
        </VendorListNoResultsText>
      </VendorListNoResultsWrapper>
    );

  return (
    <VendorsListWrapper>
      <VendorsListGridWrapper>
        <VendorsListDivider />
        {Object.keys(vendorsGridHeaderList).map(vendorGridHeaderKey => (
          <VendorsListHeader key={vendorGridHeaderKey}>
            {vendorsGridHeaderList[vendorGridHeaderKey]}
          </VendorsListHeader>
        ))}
        <VendorsListDivider />
        {mappedVendorsList.map((vendor, index) => {
          const { color, backgroundColor } = vendorStatusColorEnum(colors)[vendor.isActive] || {};
          const vendorEnglishDetails = vendor.translators.find(
            details => details.language === 'en',
          );
          return (
            <React.Fragment key={vendor.key}>
              <VendorsListItem>
                <VendorsListItemText>{vendorEnglishDetails.displayName}</VendorsListItemText>
                <SectionDivider gap={2} />
                <VendorsListItemSubText>{vendorEnglishDetails.address}</VendorsListItemSubText>
              </VendorsListItem>
              <VendorsListItem>
                <VendorListItemStatus color={color} backgroundColor={backgroundColor}>
                  {vendorStatusEnum.getKeyByValue(vendor.isActive)}
                </VendorListItemStatus>
              </VendorsListItem>
              <VendorsListItem>
                <VendorsListItemText>{vendor.managerName}</VendorsListItemText>
              </VendorsListItem>
              <VendorsListItem>
                <VendorsListItemText>{vendor.email}</VendorsListItemText>
                <SectionDivider gap={2} />
                <VendorsListItemSubText>{vendor.contactNumber}</VendorsListItemSubText>
              </VendorsListItem>
              <VendorsListItem>
                <VendorsListItemText>
                  {stringsData.vendorsList.vendorDistanceUnit(vendor.maxDeliveryDistance)}
                </VendorsListItemText>
                <VendorsListItemSubText>
                  {stringsData.vendorsList.vendorPartnershipDistanceUnit(
                    vendor.maxDeliveryDistancePS,
                  )}
                </VendorsListItemSubText>
              </VendorsListItem>
              <VendorsListItem>
                <VendorsListItemText>{vendor.deliveryFee.toFixed(2)}</VendorsListItemText>
              </VendorsListItem>
              <VendorsListItem>
                <VendorListIconBtn
                  icon={"'\\e90a'"}
                  onClick={() => handleVendorEditButtonClick(vendor)}
                  data-testid={`EditVendorBtn-${index}`}
                />
              </VendorsListItem>
              <VendorsListDivider />
            </React.Fragment>
          );
        })}
      </VendorsListGridWrapper>
    </VendorsListWrapper>
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

export default VendorsList;

VendorsList.propTypes = {
  stringsData: PropTypes.shape({
    vendorsList: PropTypes.shape({
      vendorGridNoResultsFound: PropTypes.string,
      vendorGridHeader: PropTypes.shape({}),
      vendorGridItemCount: PropTypes.string,
      vendorPartnershipDistanceUnit: PropTypes.func,
      vendorDistanceUnit: PropTypes.func,
    }),
  }).isRequired,
  mappedVendorsList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  vendorStatusEnum: PropTypes.shape({
    getKeyByValue: PropTypes.func,
  }).isRequired,
  vendorStatusColorEnum: PropTypes.func.isRequired,
  handleVendorEditButtonClick: PropTypes.func.isRequired,
};
